import { Base } from '@studiometa/js-toolkit';
import { Panel } from '@studiometa/ui';
import NameGuideFilter from './NameGuideFilter.js';
import Menu from './Menu.js';

/**
 * NameGuide component
 */
export default class NameGuide extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'NameGuide',
    refs: ['panel-btn', 'reset'],
    components: {
      Panel,
      NameGuideFilter,
      Menu,
    },
  };

  /**
   * Autoclose menus to not have 2 open at the same time
   * @param {HTMLElement} el
   */
  onMenuToggling(el) {
    this.$children.Menu.forEach((menu) => {
      if (el !== menu.$el) {
        menu.close();
      }
    });
  }

  /**
   * onPanelBtnClick
   */
  onPanelBtnClick() {
    if (this.$children.Panel.length >= 1) {
      this.$children.Panel[0].open();
    }
  }

  /**
   *
   */
  onResetClick() {
    this.$children.NameGuideFilter.forEach((filter) => {
      filter.$refs.checkbox.forEach((checkbox) => {
        checkbox.checked = false;
      });
      filter.updatePlaceholder();
    });
  }
}
